import { render, staticRenderFns } from "./SfInput.vue?vue&type=template&id=5f83a628&"
import script from "./SfInput.vue?vue&type=script&lang=js&"
export * from "./SfInput.vue?vue&type=script&lang=js&"
import style0 from "./SfInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports